import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`

export const Title = styled.div`
  margin-bottom: ${props => props.theme.spacing.sp16};
`
